import {h, Component} from 'preact';
import {connect} from 'react-redux';
import Renderer from '../canvas/renderer';

import reduce from '../reducers';
import * as actions from '../actions';

import constants from '../constants';
import util, {getFillZoom, getFitZoom} from '../util';
import store from '../store';
import {afterZoomReposition} from "../canvas/zoom";

export default @connect(reduce, actions)
class Zoom extends Component {
  constructor() {
    super();
    this.state = {
        zoom: 100
    };

    this.setZoom = (newZoom, animate, isFill) => {
      if (constants.SCALED_ZOOM_APPROACH || constants.ZUM_ZOOM_APPROACH) {
        if (constants.ZUM_ZOOM_APPROACH) {
          $('#pages').css('zoom' , newZoom / 100);
        } else {
          let transformOrigin = 'center top 0px';
          if (constants.SCALED_ZOOM_APPROACH_TOP_LEFT) {
            transformOrigin = 'left top 0px';
          }

          const $page = $('#pages');
          $page.css({
            'transform-origin':         transformOrigin,
            '-webkit-transform-origin': transformOrigin,
            'transition': animate ? 'all 0.3s ease-out' : ''
          });

          $page.css('transform','scale(' + newZoom / 100 + ')');
          afterZoomReposition(isFill ? isFill : false)
        }
      } else {
        Renderer.setZoom(newZoom);
      }
    };
        
    this.zoomIn = (event) => {
        event.stopPropagation();

        let newZoom = constants.zoomSteps[constants.zoomSteps.indexOf(util.roundToZoomStep(this.props.zoom))+1];
        const maxZoom = store.getState().maxZoom;
        const minZoom = store.getState().minZoom;
        if (!newZoom) newZoom = maxZoom;
        if (newZoom > maxZoom) newZoom = maxZoom;
        if (newZoom < minZoom) newZoom = minZoom;
        if(store.getState().zoom === newZoom){
          return true;
        }

        this.props.updateZoom(newZoom);

        this.setZoom(newZoom);

    };

    this.zoomOut = (event) => {
        event.stopPropagation();

        let newZoom = constants.zoomSteps[constants.zoomSteps.indexOf(util.roundToZoomStep(this.props.zoom))-1];
        const maxZoom = store.getState().maxZoom;
        const minZoom = store.getState().minZoom;
        if (!newZoom)  newZoom = minZoom;
        if (newZoom > maxZoom) newZoom = maxZoom;
        if (newZoom < minZoom) newZoom = minZoom;
        //if (util.isMenu(size) && newZoom < constants.MIN_ZOOM_MENU) newZoom = constants.MIN_ZOOM_MENU;
        if(store.getState().zoom === newZoom){
          return true;
        }

        this.props.updateZoom(newZoom);

        this.setZoom(newZoom);

    };

    this.fill = (event) => {
      event.stopPropagation();
      let newZoom = getFillZoom();

      this.props.updateZoom(newZoom);
      this.setZoom(newZoom, false, true);

      let scroll = 0;
      const pageX = $('#page-1').get(0).getBoundingClientRect().x;
      let leftSideWidth = $('#app-aside').width();
      let leftSideRequiredWidth = leftSideWidth + 50;
      if(pageX > leftSideRequiredWidth){
        scroll = pageX - leftSideWidth - 25;
        $(window).scrollLeft(scroll);
      }
            
      $(window).scrollTop($('#' + util.getFirstVisiblePage()).offset().top - 125);
    };
        
    this.fit = (event) => {
      event.stopPropagation();
      let newZoom = getFitZoom();

      this.props.updateZoom(newZoom);
      this.setZoom(newZoom, false);


      let scroll = 0;

      let pageBox = $('#page-1').get(0).getBoundingClientRect();

      const pageX = pageBox.x;
      let leftSideWidth = $('#app-aside').width();
      let leftSideRequiredWidth = leftSideWidth + 50;

      if ((pageSize.width > pageSize.height) && pageX > leftSideRequiredWidth) {
        scroll = pageX - leftSideWidth - 25;
        $(window).scrollLeft(scroll);
      }
      $(window).scrollTop($('#' + util.getFirstVisiblePage()).offset().top - 125);
    };
  }

  handleKeyDown(ev) {
    if (ev.metaKey || ev.ctrlKey || ev.altKey) {
      var plus_key = util.isFirefox() ? 61 : constants.PLUS_KEY;
      var minus_key = util.isFirefox() ? 173 : constants.MINUS_KEY;
      if (ev.keyCode === plus_key) {
        $('.page-tools .btn.plus').trigger('click');
      } else if (ev.keyCode === minus_key) {
        $('.page-tools .btn.minus').trigger('click');
      }
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown, false);
  }

  render (props, state) {
    const fullscreen = null;
    return (
      <div className="page-tools">
        <div className={'btn zoom-percent'} style="display: inline-flex; align-items: center; justify-content: center; font-size: 12px;">
            { Math.round(props.zoom / props.zoomAdjusted * 100) }%
        </div>
        <div id="safeZone" className="btn plus" onClick={(event) => this.zoomIn(event) }>
            <svg style="position: relative; top: -1px;"><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-icon-zoom-in" } /></svg>
        </div>
        <div id ="ruler" className="btn minus" onClick={(event) => this.zoomOut(event)} style="display: inline-flex; align-items: center; justify-content: center;">
            <svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-icon-zoom-out" } /></svg>
        </div>
        <div id="layout-guides" className="btn fill" onClick={(event) => this.fill(event)} style="display: inline-flex; align-items: center; justify-content: center;font-size: 11px;">
          Fill
        </div>
        <div className="btn fit" onClick={(event) => this.fit(event)} style="display: inline-flex; align-items: center; justify-content: center;font-size: 11px;">
          Fit
        </div>
        { fullscreen }
      </div>
    )
  }
}
